import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";
import { stringToArray } from "utilities/string/string";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { type ISelectedEntityCopyProps } from "commonComponents/entity/list/SelectedEntityCopy/SelectedEntityCopy/SelectedEntityCopy";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

const SelectedEntityCopy = lazyLoadWithRetry(() => import("./SelectedEntityCopy"));

export const RouteSelectedEntityCopy = (
    props: Omit<ISelectedEntityCopyProps, "selectedEntityIds" | "history" | "location" | "match">,
) => (
    <RouteRelative
        path={routes.list.selectedEntityCopy}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <SelectedEntityCopy
                        {...props}
                        {...routeProps}
                        selectedEntityIds={stringToArray(routeProps.match.params.ids)}
                    />
                </BTSuspense>
            );
        }}
    />
);
